// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__+gM2N","lastLink":"HeadPage_lastLink__EymF-"};